import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion/accordion";
import { useSignalStatus } from "../signal-status/use-signal-status";
import { DisconnectedIcon } from "@/components/icons/connection";
import { useTranslation } from "react-i18next";

export interface OperatorAwarenessAccordionItemProps {
  accordionValue: string;
}

export function OperatorAwarenessAccordionItem({
  accordionValue,
}: OperatorAwarenessAccordionItemProps) {
  const { t } = useTranslation();
  const { hasError, connected } = useSignalStatus();

  if (connected || !hasError) return null;

  return (
    <AccordionItem
      value={accordionValue}
      className="overflow-hidden flex-none animate-accordion-fade-in"
    >
      <AccordionTrigger className="bg-destructive">
        <div className="flex gap-2 items-center">
          <DisconnectedIcon className="h-5 w-5" />
          <p>{t("operatorAwareness.connection.title")}</p>
        </div>
      </AccordionTrigger>
      <AccordionContent className="bg-destructive-muted">
        <p>{t("operatorAwareness.connection.message")}</p>
      </AccordionContent>
    </AccordionItem>
  );
}
